<template>
  <div class="help-center-search-empty-state__component">
    <p class="help-center-search-empty-state__text">
      We're sorry, but no results found.
    </p>
    <a
      target="_blank"
      rel="noopener"
      href="/contact"
      class="help-center-search-empty-state__link"
    >
      Contact Us
    </a>
  </div>
</template>

<style lang="scss">
@import 'help-center/mixins';

.help-center-search-empty-state {
  &__component {
    @include help-center-font(16);
    height: 252px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__text {
    color: var(--help-center-text);
  }

  &__link {
    @include help-center-highlight-link;
  }
}
</style>
